import { get, post } from '@/utils/apiBase.js';

// 获取创意类别列表
const getIdeaCategoryList = option => {
    return get('/apis/project/cp/get_idea_category_list', option)
}
// cp获取创意详细信息
const getIdeaInfo = option => {
    return get('/apis/project/cp/get_idea_info', option)
}
// 发布创意
const createIdea = option => {
    return post('/apis/project/cp/create_idea', option)
}
// 编辑创意
const editIdea = option => {
    return post('/apis/project/cp/edit_idea', option)
}
// 发布创意更新
const createIdeaUdpate = option => {
    return post('/apis/project/cp/create_idea_udpate', option)
}
// 待修改状态编辑创意
const postModifiedIdea = option => {
    return post('/apis/project/cp/modified_idea', option)
}
// 获取众筹更新详情
const getIdeaUpdateInfo = option => {
    return get('/apis/project/cp/idea_update_info', option)
}
// 编辑创意更新
const postModifiedIdeaUpdate = option => {
    return post('/apis/project/cp/edit_idea_update', option)
}
// 保存草稿
const postSaveIdeaDraft = option => {
    return post('/apis/project/cp/save_idea_draft', option)
}
// 人工审核
const ideaApplyReview = option => {
    return post('/apis/project/cp/idea_apply_review', option)
}
export default {
    getIdeaCategoryList,
    getIdeaInfo,
    createIdea,
    editIdea,
    createIdeaUdpate,
    postModifiedIdea,
    getIdeaUpdateInfo,
    postModifiedIdeaUpdate,
    postSaveIdeaDraft,
    ideaApplyReview
}
